import qs from "qs";
import { ColumnState } from "ag-grid-community";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

export const cleanUpQuery = (str: string) => (str.charAt(0) === "?" ? str.substring(1) : str);

export const getFiltersFromQueryString = (queryString: string) => {
    if (!queryString) {
        return {};
    }
    const cleanQueryString = cleanUpQuery(queryString);
    if (!cleanQueryString) {
        return {};
    }
    const allQueryParams = qs.parse(cleanQueryString);
    const sort = allQueryParams.sort;
    delete allQueryParams.sort;
    return { filters: allQueryParams, sort };
};

export const getQueryParamsFromObjects = (
    filters: { [key: string]: any },
    columnStates: ColumnState[]
) => {
    const sortArray: string[] = columnStates
        .filter((columnState) => !!columnState.sort)
        .map(({ colId, sort }) => [colId, sort].join(","));

    //filter type should always be the same as on init, so we remove filterType from all filter models
    Object.keys(filters).forEach((filerName) => {
        delete filters[filerName].filterType;
    });

    if (Object.keys(filters).length === 0 && sortArray.length === 0) {
        return "";
    }

    return qs.stringify({ ...filters, sort: sortArray });
};

export const exportServerSide = (data: Array<any>, fileName: string) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
    /*   const url = window.URL.createObjectURL(
        new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.xlsx`); //or any other extension
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link); */
};

export const getApplyColumnState: any = (sortArray: string[]) => {
    return sortArray.map((sortValue) => {
        const [colId, sort] = sortValue.split(",file-saver");

        return {
            colId,
            sort,
        };
    });
};

export const filterParams = {
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
        const dateAsString = cellValue;
        if (dateAsString === null) return -1;
        const dateParts = dateAsString.split("/");
        const cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
        );

        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
        return 0;
    },
    inRangeFloatingFilterDateFormat: "DD-MM-YYYY",
};

export function columnParForDates(dateName: string) {
    return {
        comparator: dateComparator,
        valueFormatter: ({ data }: any) =>
            data[dateName] ? moment(data[dateName]).format("DD/MM/YY") : "n/d",
        valueGetter: ({ data }: any) =>
            data[dateName] ? moment(data[dateName]).format("DD/MM/YYYY") : null,
        filter: "agDateColumnFilter",
    };
}

export function dateComparator(date1: string | null, date2: string | null) {
    let timeStamp1 = 0;
    let timeStamp2 = 0;
    if (date1) {
        timeStamp1 = new Date(moment(date1, "DD/MM/YYYY").format("YYYY-MM-DD")).getTime();
    }
    if (date2) {
        timeStamp2 = new Date(moment(date2, "DD/MM/YYYY").format("YYYY-MM-DD")).getTime();
    }
    return timeStamp1 - timeStamp2;
}
